const options = {
  5: "bg-gray-500/5",
  10: "bg-gray-500/10",
  25: "bg-gray-500/25",
  50: "bg-gray-500/50",
  75: "bg-gray-500/75",
  90: "bg-gray-500/90",
  100: "bg-gray-500",
};

const from = {
  5: "from-gray-500/5",
  10: "from-gray-500/10",
  25: "from-gray-500/25",
  50: "from-gray-500/50",
  75: "from-gray-500/75",
  90: "from-gray-500/90",
  100: "from-gray-500",
};

export default function getBackgroundGray500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
